import {ModelClass} from "../../ModelClass";

/**
 * 앨범(DIGITAL) 별 내역
 */
export class AlbumDigitalRevenueItem extends ModelClass {
    constructor(revenueItem) {
        super(revenueItem);
        this.revenueMonth = 0; //분배월
        this.calculateMonth = 0;//정산월
        this.saleStartDate = null;//발매일
        this.distributor = null;// 발매사
        this.assetType = null; // 카탈로그 구분
        this.assetCode = null; // 앨범 코드
        this.assetName = null;// 앨범 명
        this.artist = null; // 아티스트
        this.albumType = null; // 앨범 유형
        this.cntStream = 0;//스트리밍 수
        this.cntDownload = 0;//다운로드 수
        this.cntEtc = 0;//기타/판매 수
        this.sumRevenueMoney = 0; // 판매액 (매출)
        this.sumRevenueFee = 0; // 수수료
        this.sumRevenueTotal = 0; // 수익 (수수료 제외)
        this.init(revenueItem);
    }

    init(revenueItem) {
        Object.keys(this).forEach(keyName => {
            switch (keyName) {
                case 'revenueMonth':
                case 'calculateMonth':
                case 'serviceMonth':
                    if (revenueItem?.[keyName]) {
                        this[keyName] = this.getYearMonthStr(revenueItem[keyName], this.fmt_yyyyMM_dot);
                    }
                    break;

                case 'saleStartDate':
                    this[keyName] = this.getDateToStr(revenueItem[keyName]);
                    break;

                case 'cntStream':
                case 'cntDownload':
                case 'cntEtc':
                case 'sumRevenueMoney':
                case 'sumRevenueFee':
                case 'sumRevenueTotal':
                    this[keyName] = this.getNumberWithDecimaPoint(revenueItem?.[keyName], 2);
                    break;

                default:
                    if (revenueItem?.[keyName]) {
                        this[keyName] = revenueItem[keyName];
                    }
                    break;
            }
        });
    }
}